<template>
  <div class="step3">
    <div class="select-con">
      <div class="mb-2">Select Ship-TO for Order:</div>
      <model-select :options="options"
                    v-model="selectValue"
                    placeholder="Please select allocation address">
      </model-select>
    </div>
    <div class="button-con">
      <CButton color="green" text="Next" :disabled="nextDisabled"  @click="onNextClick"/>
      <div class="ml20">
        <CButton color="orange" text="Back" @click="onBack"/>
      </div>
      <div class="ml20">
        <CButton color="red" text="Cancel"  @click="onCancel"/>
      </div>
    </div>
  </div>
</template>

<script>
import CButton from "../common/CButton.vue";
import { ModelSelect } from 'vue-search-select';


export default {
  name: 'Steps3',
  components:{
    CButton,
    ModelSelect
  },
  props: {
    addresses: Array,
    onNext: Function,
    onBack: Function,
    onCancel: Function,
  },
  data(){
    return{
      selectValue: {
        value: '',
        text: ''
      },
    }
  },
  computed: {
    options(){
      return this.addresses.map((item,index)=>{
        return {
          value: index,
          text: item.title
        }
      });
    },
    nextDisabled(){
      return this.selectValue.value==='';
    }
  },
  mounted() {
    // this.selectValue = {
    //   value: 0,
    //   text: this.addresses[0].title
    // }

  },
  methods: {
    onNextClick(){
      const index = Number(this.selectValue.value);
      this.onNext({
        address_id: this.addresses[index].id,
        address_name:  this.addresses[index].title
      })
    }
  }
}
</script>